(function(){
  var timeoutMs    = 60000;
  var startTime = Date.now()
  var timer;

  function resetTimer() {
    clearTimeout(timer);
    timer = setTimeout(endSession, timeoutMs);
  }

  function endSession() {
    var totalTime = Date.now() - startTime;
    var seconds = Math.round(totalTime / 1000);
    if (window.heap && typeof heap.track === 'function') {
      if (seconds < 30)
      {
        heap.track('Less than 30', {
          url: window.location.pathname
        });
      }
      else if (seconds < 60)
      {
        heap.track('Less than 60', {
          url: window.location.pathname
        });
      }
      else if (seconds < 90)
      {
        heap.track('Less than 90', {
          url: window.location.pathname
        });
      }
      else
      {
        heap.track('Greater than 90', {
          url: window.location.pathname
        });
      }
    }
    cleanup();
  }

  function cleanup(){
    ['click','scroll','keydown'].forEach(evt =>
      document.removeEventListener(evt, resetTimer)
    );
    window.removeEventListener('beforeunload', endSession);
    clearTimeout(timer);
  }

  ['click','scroll','keydown'].forEach(evt =>
    document.addEventListener(evt, resetTimer)
  );
  window.addEventListener('beforeunload', endSession);

  // start
  timer = setTimeout(endSession, timeoutMs);
})();
